import React from 'react';
import styled from 'styled-components';
import { navy } from '@zocdoc/branding/colors';
import { Icon } from './_base';

const NeedInfoSVG = styled(Icon).attrs({ viewBox: '0 0 38 40' })`
    width: 0.95em;
`;

const NeedInfo = ({ color = navy, ...props }) => (
    <NeedInfoSVG data-test="need-info-icon" {...props}>
        <path
            d="M21.5,3.1V0h-5.1v3.1c-9,1.2-16,9-16,18.3C0.5,31.7,8.8,40,19,40c10.2,0,18.5-8.3,18.5-18.5 C37.5,12.1,30.6,4.4,21.5,3.1z M19,35.6c-7.8,0-14.1-6.3-14.1-14.1c0-7.8,6.3-14.1,14.1-14.1c7.8,0,14.1,6.3,14.1,14.1 C33.1,29.3,26.8,35.6,19,35.6z"
            fill={color}
        />
        <path
            d="M19.5,11.4c-3.4,0-6.2,2.8-6.2,6.2h4.4c0-1,0.8-1.8,1.8-1.8c1,0,1.8,0.8,1.8,1.8c0,1-0.8,1.8-1.8,1.8h-3.2 v5.8h4.4v-1.6c2.8-0.6,5-3.1,5-6C25.6,14.2,22.9,11.4,19.5,11.4z"
            fill={color}
        />
        <rect fill={color} height="4.4" width="4" x="16.5" y="26.4" />
    </NeedInfoSVG>
);

export { NeedInfo as default, NeedInfo };
